import AllRoutes from "./AllRoutes/Routes";
import Navbar from "./Components/Navbar";
function App() {
  return (
    <>
      <Navbar />
      <AllRoutes />
    </>
  );
}

export default App;
